import { Link } from 'react-router-dom';
import { noDeviceReminderNote } from '@cerebro-diem/core';
import { errorMessage } from '../services/errors';
import { useHomeWarnings } from '../services/health';

/**
 * The one line beside a reminder being set when the account has no device to
 * receive it (CER-150), with the way to Settings, where this browser is
 * turned on. Nothing when a device will receive it; a check that failed says so.
 */
export default function NoDeviceNote() {
  const query = useHomeWarnings();
  if (query.isPending) return null;
  if (query.isError) {
    return <p className="text-sm text-error">Could not check whether your reminders reach a device: {errorMessage(query.error)}</p>;
  }
  const note = noDeviceReminderNote(query.data);
  if (note === null) return null;
  return (
    <p role="note" className="text-sm text-error">
      {note}{' '}
      <Link to="/settings" className="underline">
        Turn notifications on in Settings
      </Link>
      .
    </p>
  );
}
